import { Injectable } from '@angular/core';
import { NavigationItemInterface } from "./common/navigation-item.interface";
import { BehaviorSubject } from "rxjs";
import { navigationItems } from './common/navigation-items.const';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {

  private navigationItems: BehaviorSubject<NavigationItemInterface[]> = new BehaviorSubject<NavigationItemInterface[]>(navigationItems);

  getNavigationItemsObservable() {
    return this.navigationItems.asObservable();
  }


}
